import { useEffect, useState } from "react";
import { Form, Button, Row, Container, Col } from "react-bootstrap";
import { GenericForm } from "../../Component/GenericForm/GenericForm";
import { Api } from "../../Helpers/axios/axios";
import { formInterface } from "../../Component/GenericForm/formInterface";
import { useNavigate, useParams } from "react-router-dom";
import { PageHeader } from "../../Component/Common/Headers";
import { LoadingSpinner } from "../../Component/Spinner/LoadingSpinner";
import { role } from "../../Helpers/commonFunction/commonFunction";

export const UserForm = () => {
  const url = "/users"
  const navigate = useNavigate();
  const { id } = useParams();

  //Form Data
  const config: formInterface[] = [
    { type: "text", name: "Full Name", key: "name", require: true, md:4 },
    { type: "select", name: "Role", key: "role", options:role ,require: true, md:4 },
    { type: "text", name: "Email", key: "email", require: true, md:4 },
    { type: "text", name: "Password", key: "password", require: true, md:4 }
  ];

  let config2: formInterface[] = [
    { type: "text", name: "Full Name", key: "name", require: true, md:4 },
    { type: "select", name: "Role", key: "role", options:role ,require: true, md:4 },
    { type: "text", name: "Email", key: "email", require: true, md:4 },
  ];

  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if(id){
      fetch(id);
    }
  }, [id]);

  const fetch = (id:any) => {
    setLoading(true);
    Api.get(`${url}/${id}`).then((res: any) => {
        setData(res);
      })
      .catch((e) => {
        alert(e?.message || e);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const Submit = async (e: React.FormEvent<HTMLInputElement> | any) => {
    e.preventDefault();
    if(id){
        Update();
    }
    else{
      Create();
    }
  };

  const Update = () =>{
    setLoading(true);
    Api.put(`${url}/${id}`,data).then((res: any) => {
      navigate(`/UserList`);
      })
      .catch((e) => {
        alert(e?.message || e);
      }).finally(()=>{
        setLoading(false);
      }); 
  }

  const Create = () =>{
        setLoading(true);
        Api.post(`auth/register`,data).then((res: any) => {
          navigate(`/UserList`);
        })
        .catch((e) => {
          alert(e?.message || e);
        }).finally(()=>{
          setLoading(false);
        });
  }

  const onChange = (key: string, value: any) => {
    let d = { ...data };
    d[key] = value;
    setData(d);
  };

  return (
    <Container>
      {loading && <LoadingSpinner overlay text="Saving User..." />}
      <PageHeader 
        title={id ? 'Edit User' : 'Add New User'} 
        subtitle="Manage system user profiles and access" 
      />
      <Form onSubmit={Submit}>
        <Row>
          {GenericForm(id? config2: config, onChange, data)}
          <Col md={12}>
            <Button className="mt-4 professional-submit-btn" type="submit">
              Submit
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};
